import * as React from 'react';
import 'rc-tooltip/assets/bootstrap.css';
import { canHover } from 'utils';
const Tooltip = require('rc-tooltip').default;

interface Props {
  text: string;
  placement?: string;
  hide?: boolean;
  disabled?: boolean;
}

export default class extends React.Component<Props> {
  render() {
    if (!canHover()) {
      return <>{this.props.children}</>;
    }

    const extras: any = {};
    if (this.props.hide) {
      extras.visible = false;
    }
    return (
      <Tooltip
        placement={this.props.placement ? this.props.placement : 'top'}
        overlay={<span>{this.props.text}</span>}
        destroyTooltipOnHide={true}
        mouseEnterDelay={0.25}
        {...extras}
      >
        {this.props.disabled ? (
          <span>{this.props.children}</span>
        ) : (
          this.props.children
        )}
      </Tooltip>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/components/ButtonTooltip.tsx